const DEFAULT_SITE_UTM_PARAMS = {
  utm_source: 'Events Platform',
  utm_medium: 'website',
}

export const generateUrlWithUtmParams = (baseUrl, utmParams, includeDefaultParameters = true) => {
  let url = new URL(baseUrl)

  if (includeDefaultParameters) {
    utmParams = { ...utmParams, ...DEFAULT_SITE_UTM_PARAMS }
  }

  for (const [key, value] of Object.entries(utmParams)) {
    url.searchParams.append(key, value)
  }

  return url.toString()
}

export const GCA_LOGO_URL_NAVY = 'https://images.jumpstart.me/frontend/careers/gca-logo-navy.png'
